export const TOKEN_KEY = "studentToken_key";
